export enum ROLE {
    SUPER_ADMIN = 1,
    LOCAL_ADMIN = 2,
    USER = 3,
}
